import React from "react";
import { Link } from "react-router-dom";
import { IconButton, Box } from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import FileCopyIcon from "@mui/icons-material/FileCopy";

export const RoutingGuideRecordsColumns = (handleEdit, handleDelete, handleCopy) => {
  return [
    {
      field: "test",
      headerName: "Copy",
      flex: 1,
      minWidth: 50,
      renderCell: (params) => (
        <div className="flex gap-2">
          <IconButton
            aria-label="copy"
            onClick={() => handleCopy(params.row)}
            size="small"
          >
            <FileCopyIcon className="edit-color" />
          </IconButton>
        </div>
      )

    },
    {
      field: "ship_from_zip1",
      headerName: "Ship From Zip1",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "ship_from_zip2",
      headerName: "Ship From Zip2",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "consolidator_name",
      headerName: "Consolidator",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "dc_name",
      headerName: "DC",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "store",
      headerName: "Store",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "department",
      headerName: "Department",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "u_min",
      headerName: "UMin",
      flex: 0.7,
      minWidth: 90,
    },
    {
      field: "u_max",
      headerName: "UMax",
      flex: 0.7,
      minWidth: 90,
    },
    {
      field: "wt_min",
      headerName: "Wt Min",
      flex: 0.7,
      minWidth: 90,
    },
    {
      field: "wt_max",
      headerName: "Wt Max",
      flex: 0.7,
      minWidth: 90,
    },
    {
      field: "ship_message",
      headerName: "Ship Message",
      flex: 1.2,
      minWidth: 150,
    },
    {
      field: "service_level_name",
      headerName: "Service Level",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "carrier_name",
      headerName: "Carrier",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "contact",
      headerName: "Contact",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "edit",
      headerName: "Actions",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div className="flex gap-2">
          <IconButton 
            aria-label="edit" 
            onClick={() => handleEdit(params.row)}
            size="small"
          >
            <ModeEditIcon className="edit-color" />
          </IconButton>
          <IconButton
            aria-label="delete"
            onClick={() => handleDelete(params.row)}
            size="small"
          >
            <DeleteIcon className="delete-color" />
          </IconButton>
        </div>
      ),
    },
  ];
};

export const RoutingGuidesColumn = (handleDelete) => {
  return [

    {
      field: "guide_name",
      headerName: "Guide Name",
      width: 200,
      sortable: true, // Disable sorting
      renderCell: (params) => {
        return (
          <Link
            to={{
              pathname: `/dashboard/routing-guides/${params.row.routing_guide_id}`,
              state: { rowData: params.row },
            }}
            style={{
              textDecoration: "none",
              color: "#2196f3",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent row click event from triggering
            }}
          >
            {params.row.guide_name}
          </Link>
        );
      },
    },

    {
      field: "division_name",
      headerName: "Division",
      width: 180,
      sortable: true, // Disable sorting
    },
    {
      field: "supplier_site_id",
      headerName: "Supplier Site ID",
      width: 180,
      sortable: true, // Disable sorting
    },
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      width: 200,
      sortable: true, // Disable sorting
    },
    {
      field: "publish_date",
      headerName: "Publish Date",
      width: 200,
      sortable: true, // Disable sorting
      //trim date
      renderCell: (params) => params.row.publish_date? params.row.publish_date.slice(0, 10) : '',
    },
    {
      field: "commodity_code",
      headerName: "Commodity Code",
      width: 200,
      sortable: true,
      renderCell: (params) => `${params.row.commodity_code} - ${params.row.commodity_code_name}`,
    },
    
    {
      field: 'edit',
      headerName: 'Actions',
      width: 140,
      renderCell: (params) => (
          <>
              <IconButton aria-label="delete" onClick={() => handleDelete(params.row)}>
                  <DeleteIcon className='ml-5 delete-color' />
              </IconButton>
          </>
      )
    }
  ];

};
